import { useTranslation } from "react-i18next";
import { CollapsibleSection } from "@/components/CollapsibleSection";
import { useAgreementData } from "../../hooks";
import { formatDateTime } from "@/lib/utils/formatters";
import { CalendarClockIcon } from "lucide-react";
import { UserListLink } from "@/components/UserListLink";

export const AgreementHistorySection = () => {
  const { t } = useTranslation();
  const { history } = useAgreementData();

  if (!history || history.length === 0) {
    return null;
  }

  return (
    <CollapsibleSection title={t("agreements.history.title")}>
      <div className="space-y-2">
        {history.map((entry, index) => (
          <div
            key={index}
            className="relative flex items-center gap-2 pl-6 after:absolute after:left-[0.6rem] after:top-6 after:bottom-[-0.5rem] after:w-px after:bg-border after:content-[''] last:after:hidden"
          >
            <CalendarClockIcon className="absolute left-0 top-1 h-3.5 w-3.5 text-muted-foreground" />

            <p className="text-sm flex items-center gap-2 flex-wrap">
              <span className="font-bold">
                {t(`agreements.history.actions.${entry.action}`)}
              </span>
              <span className="text-muted-foreground">
                {formatDateTime(entry.updated_at)}
              </span>
              <span className="text-muted-foreground">
                {entry.user_full_name} ({entry.user_role_name})
              </span>
              <UserListLink userId={entry.user_id} className="w-4 h-4" />
            </p>
          </div>
        ))}
      </div>
    </CollapsibleSection>
  );
};
